const vodStyles = {
    // grid: `columns-2 md:columns-6 p-5 text-center w-max`,
    // gridWrapper: `flex items-center justify-center`

    gridWrapper: ``,
    grid: `flex flex-wrap items-center justify-center`,
}

export default vodStyles